export default __webpack_public_path__ + "static/media/customers.9f91a267.svg";